import { AgTechClickEventHandler, useClickable } from '../Buttons/AgTechButtons'
import { useAgTechTooltip } from '../Portals/Popups/AgTechTooltipContainer'
import React, { CSSProperties, useRef } from 'react'

export const AgTechSuccessIcon = (props: { classes?: string }) => {
    return (
        <i className={`agtech-icon fas fa-check ${props.classes ?? ''}`} style={{color: 'green'}} />
    )
}

export const AgTechSuccessCircleIcon = (props: { size?: number, classes?: string }) => {
    return (
        <i
            className={`agtech-icon fas fa-check font-color-white font-size-large bg-green centered rounded-circle container ${props.classes ?? ''}`}
            style={{
                height: props.size ?? 36,
                width: props.size ?? 36,
            }}
        />
    )
}

export const AgTechGeneralIcon = () => {
    return (
        <i className="agtech-icon fas fa-circle font-size-very-small font-color-border" />
    )
}

export const AgTechWarningIcon = (props: { classes?: string, style?: CSSProperties }) => {
    return (
        <i className={`agtech-icon fas fa-exclamation-triangle ${props.classes ?? ''}`} style={{ color: 'goldenrod', ...props.style }} />
    )
}

export const AgTechCreatedIcon = () => {
    return (
        <i className="agtech-icon fas fa-plus" style={{color: 'green'}} />
    )
}

export const AgTechLoadingIcon = () => <i className="agtech-icon fas fa-spinner font-color-secondary" />

export const AgTechUpdatedIcon = () => {
    return (
        <i className="agtech-icon fas fa-pen font-color-highlight" />
    )
}

export const AgTechErrorIcon = (props: { size?: number, classes?: string }) => {
    let iconSize = props.size ?? 36;

    return (
        <div className={`centered border border-red-700 text-red-700 bg-white flex ${props.classes}`} style={{ height: iconSize, width: iconSize, borderRadius: '50%' }}>
            <i className='bi bi-exclamation centered container' style={{ fontSize: iconSize * .8 }}/>
        </div>
    )
}

export const AgTechValueBadge = ({ value }: { value: string }) => {
    return (
        <div className='agtech-icon-badge'>
            {value}
        </div>
    )
}

export type AgTechClickableIconProps = {
    icon: string,
    tooltip?: string
    onClick: (e: AgTechClickEventHandler) => void,
    classes?: string,
    styles?: React.CSSProperties,
    disableIf?: boolean
}

export const AgTechClickableIcon = (props: AgTechClickableIconProps) => {
    let iconRef = useRef<HTMLElement>(null);
    let iconClickable = useClickable(iconRef);

    useAgTechTooltip<HTMLElement>({
        containerRef: iconRef,
        tooltip: props.tooltip
    });

    let handleIconClick = (e: React.MouseEvent<HTMLElement>) => {
        e.stopPropagation();
            
        props.onClick({
            ...iconClickable,
            clickEvent: e
        });
    }

    const customClasses = props.classes ?? '';
    const hoverClasses = 'hover:text-highlight-500 hover:border-highlight-500'

    return (
        <>
            <i
                ref={iconRef}
                className={`${props.icon} clickable color-changing tall centered container ${hoverClasses} ${customClasses}`}
                style={props.styles}
                onClick={handleIconClick}
                aria-disabled={props.disableIf}
            />
            {iconClickable.content()}
        </>
    )
}